import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { Action, fileDownloadActions } from "./file-download-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { baseUrl, getFilePreviewUrl, getFileUrl } from "src/utils/url-utils";
import { overlayedFetch } from "@itk/mui-components";
import { getAccessToken } from "src/backend/configure-openapi";

export function* getFileDownloadRequest(action: ReturnType<typeof fileDownloadActions.getFileDownloadRequest>) {
  try {
    const getBlobAsync = async (id: string) => {
      const url = action.payload.preview ? getFilePreviewUrl(id) : getFileUrl(id);

      if (!baseUrl) throw Error("Invalid base url");
      const file = await overlayedFetch(baseUrl, url, { headers: { Authorization: `Bearer ${getAccessToken()}` } });
      const fileName = decodeURIComponent(/filename\*=UTF-8''([^*]+\..*?(?:;|$))/.exec(file.headers.get("Content-Disposition") ?? "")?.[1] ?? "");
      const originalExtension = file.headers.get("Original-Extension");
      const blob = await file.blob();
      return { url: window.URL.createObjectURL(blob), fileName, originalExtension };
    };

    const fileInfo: { url: string; fileName: string; originalExtension: string } = yield call(getBlobAsync, action.payload.fileId);
    yield put(fileDownloadActions.getFileDownloadSuccess(action.payload.instanceId, fileInfo));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchGetFileDownloadRequest() {
  yield takeEvery(Action.GetFileDownloadRequest, getFileDownloadRequest);
}

export function* fileDownloadSaga() {
  yield all([fork(watchGetFileDownloadRequest)]);
}
